<!--
 1、本页面为直播推广页有单独的模板名称t11
 2、需要统计t11的浏览时长，这个直播推广页面同时用pageno=1来提交
 3、接收到的id和psn是售楼中心的，分享带上t11的id和psn，以及售楼中心的t9id和t9psn
 -->
<template>
  <div class="liveroominfo wrapper">
    <div class="share-top">
      {{invitename}}邀您直播看房
    </div>
    <div class="box-layer" v-if="liveInfo&&!showQrcode"  ref="getheight">
      <div class="top-layer" >
        <div class="left">
          <div class="desc">
            <span>直播人</span>
            {{liveInfo.anchorName}}
          </div>
          <div class="logo">直播时间<span></span></div>
          <div class="desc">{{liveInfo.planDateToStart}} {{liveInfo.planTimeToStart}}</div>
        </div>
        <div class="right" v-if="liveInfo.bannerImgUrl">
          <img :src="liveInfo.bannerImgUrl" />
        </div>
      </div>
      <div class="title-layer" v-if="liveInfo.anchorCompany">直播楼盘</div>
      <div class="content">{{liveInfo.anchorCompany}}</div>
      <div class="title-layer" v-if="liveInfo.briefIntroduction">直播内容</div>
      <div class="content">{{liveInfo.briefIntroduction}}</div>
      <div class="note-layer">资深顾问线上讲解，足不出户，安心选宅</div>
    </div>

    <div class="go-live" @click="goLive">
      <wx-open-launch-weapp
              id="launch-btn"
              username="gh_7743721e0a80"
              :path="wxpath"
              @launch="handleLaunchFn"
      >
        <button style="background:transparent; color:#8B663A; font-size: 18px;border: none;">进入直播间</button>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as config from "./config";
import { MessageBox, Indicator, Toast } from "mint-ui"; //上拉刷新
import { mapState, mapMutations } from "vuex";
import wxsdk from "@/utils/wxsdk";
export default {
  props: {},
  data() {
    return {
      refereename: '',
      startLive: false,
      offsetHeight: 0,
      top: 0,
      height: window.innerHeight,
      LiveQRCode: "",
      wxpath: "",
      rid: this.$route.query.rid ? this.$route.query.rid : "",
      pid: (this.$route.query.pid ? parseInt(this.$route.query.pid) : ''),
      liveInfo: null,
      navData: [],
      showyylive: false,
      phone: "",
      invitename: this.$route.query.invitename ? decodeURIComponent(decodeURIComponent(this.$route.query.invitename)) : "原圈科技",
      qrurl: "",
      issubscribe: false, //是否为粉丝
      showQrcode: false,
      showSharelive: false,
      step: 1,
      shareImg: "",
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "pageInfo",
      "isInMiniProgram",
      "shareSpreadInfo",
      "receiveSpreadInfo",
    ]),
    evenNavData: function () {
      return this.navData.filter(function (item, i) {
        return item.isHide != true;
      });
    },
  },
  methods: {
    ...mapMutations({
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO",
    }),
    handleLaunchFn(e) {
      let that = this;
      let url = "";
    },
    //进入直播间
    goLive() {
      console.log("url为：" + this.wxpath)
      if (!this.wxpath) return;
      wxsdk.wx.miniProgram.navigateTo({
        url: this.wxpath,
      });
    },
  },
  created() {
  },
  mounted() {
    let that = this;
    config.myLiveRoomByRoomId(that.rid).then((response) => {
      if (response.code == 0) {
        that.liveInfo = response.data;
        // 生成H5打开直播小程序的链接
        let grantUrl = "/pages/grant/index";
        let paramsObj = {
          roomId: that.liveInfo.roomId || undefined,
          publicOpenId: that.liveInfo.publicOpenId || undefined,
          mobile: that.phone || undefined,
          playerOpenId: that.$openid || undefined,
          passport: that.$passport || undefined
        };
        grantUrl = util.addUrlParamFromObj(
                grantUrl,
                util.filterObjRemoveUndef(paramsObj)
        );
        that.wxpath = grantUrl;
      } else {
        return MessageBox("提示", response.msg);
      }
    });
  },
};
</script>
<style lang="css" scoped>
.wrapper {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background: url("http://assets.rurushishi.com/live_room/bg_share.png") no-repeat;
  background-size: cover;
}
.go-live {
  /* position: absolute;
  bottom: 1rem;
  left: 0.65rem;
  right: .65rem; */
  width: 6.1rem;
  margin: 0 auto;
  margin-top: .6rem;
  background: #E9D29D;
  border-radius: 5px;
  padding: 10px 0;
  text-align: center;
}
.box-layer {
  /* position: absolute;
  top: 1.36rem; */
  margin: 0 auto;
  margin-top: 1.36rem;
  left: 0.65rem;
  width: 5.8rem;
  right: .65rem;
  border: 1px solid #E9D29D;
  padding: .92rem 0.2rem 0.5rem .2rem;
}
.box-layer .top-layer {
  display: flex;
  margin-bottom: 1.68rem;
}
.box-layer .top-layer .left {
  flex: 1;
  margin-right: 0.15rem;
}
.box-layer .top-layer .left .title {
  font-size: .32rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(43,42,50,1);
}
.box-layer .top-layer .left .desc {
  font-size: 0.28rem;
  margin-top: .2rem;
  font-weight: 500;
  color: #FFFFFF;
}
.box-layer .top-layer .left .desc span {
  color: #79725F;
  font-size: 0.32rem;
  font-weight: 500;
}
.box-layer .top-layer .left .logo {
  color: #ffffff;
  font-size: 0.26rem;
  background-color: #946c3e;
  margin-top: .2rem;
  width: 1.84rem;
  text-align: center;
  height: .4rem;
  line-height: .4rem;
  position: relative;
}
.box-layer .top-layer .left .logo>span{
  position: absolute;
  top: 0;
  right: -.2rem;
  width: 0;
  height: 0;
  border-top: .4rem solid #946c3e;
  border-right: .205rem solid transparent;
}
.box-layer .top-layer .right {
  width: 2rem;
  height: 2rem;
}
.box-layer .top-layer .right > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.box-layer .title-layer {
  margin-top: 0.5rem;
  color: #79725F;
  font-size: 0.32rem;
  font-weight: 500;
  margin-top: .8rem;
}
.box-layer .content {
  padding-top: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.6rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:#FFFFFF;
}
.box-layer .note-layer {
  width: 5.5rem;
  line-height: 0.5rem;
  padding-top: 0.5rem;
  text-align: center;
  font-size: .24rem;
  font-family: PingFangSC-Medium,PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  margin: 0 auto;
}
.yy-live-bg {
  position: absolute;
  bottom: -0.1rem;
  left: -0.44rem;
  width: 7.1rem;
  height: 2.28rem;
  background: url("http://assets.rurushishi.com/yq-rs-desk/yy-live-bg.png")
    no-repeat;
  background-size: 100% 100%;
}
.yy-live-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* line-height: 2.7rem; */
  padding-top: 0.85rem;
}
.yy-live-content .yy-live-btn {
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: rgba(214, 115, 81, 1);
  background: #fff;
  width: 2.24rem;
  height: 1.06rem;
  background: rgba(245, 245, 245, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  border-radius: 0.53rem;
  line-height: 1.06rem;
  text-align: center;
  font-size: 0.32rem;
}
.yy-live-content .yy-live-text {
  color: #fff;
  height: 1.06rem;
  border-radius: 0.53rem;
  line-height: 1.06rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.xcx-bg {
  position: absolute;
  bottom: -0.3rem;
  left: -0.44rem;
  width: 7.1rem;
  height: 2.66rem;
  background: url("http://assets.rurushishi.com/yq-rs-desk/xcx-bg.png")
    no-repeat;
  background-size: 100% 100%;
}
.xcx-content {
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  /* line-height: 2.7rem; */
  padding-top: 0.8rem;
}
.xcx-url {
  padding: 0rem 0.4rem;
  width: 1.54rem;
  height: 1.54rem;
}
.xcx-url > img {
  width: 1.54rem;
  height: 1.54rem;
}
.xcx-text {
  padding-left: 0.1rem;
  width: 4.4rem;
  color: #fff;
  line-height: 0.4rem;
  font-size: 0.28rem;
}

/* 底部导航 */
.tabbar {
  width: 100%;
  height: 40px;
  padding-bottom: 20px;
  padding-top: 10px;
  background: #fff;
  /* background: #f5af19; */
  /* background: linear-gradient(to right, #f5af19, #f12711); */
  /* background: linear-gradient(to right, #4CB8E9, #007DA6); */
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  /*justify-content: center;*/
  justify-content: space-around;
  z-index: 10;
  /* border-top: 1px solid #c6c6c6; */
}

.tabbar_item {
  text-align: center;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
}

.tabbar_item .tabbar_icon {
}

.tabbar_item .tabbar_icon > img {
  width: 20px;
  height: 20px;
  padding: 5px;
}

.tabbar_item .tabbar_text {
  display: inline-block;
  font-size: 13px;
}
.tabbar_wonder_h5 {
  width: 18%;
  flex-direction: column;
  font-size: 13px;
}
.tabbar_wonder {
  width: 26%;
  flex-direction: column;
  font-size: 13px;
}
.tabbar_wonder .tabbar_text {
  font-size: 12px;
  color: #333333;
}
.tabbar_wonder .tabbar_icon {
  margin-right: 0px;
}
.tabbar_poster_h5 {
  width: 18%;
  flex-direction: column;
  font-size: 13px;
}
.tabbar_chat_h5 {
  width: 32%;
  background: linear-gradient(
    165deg,
    rgba(122, 189, 233, 1),
    rgba(116, 165, 242, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}
.tabbar_chat_h5.zd {
  background: #f22321;
  border-radius: 20px;
}
.tabbar_chat {
  width: 37%;
  background: linear-gradient(
    165deg,
    rgba(65, 196, 244, 1),
    rgba(98, 153, 244, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}
.tabbar_wonder_zb {
  width: 32%;
  background: rgba(81,132,214,1);
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}
.tabbar_share_h5 {
  width: 32%;
  background: rgba(214,115,81,1);
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}
.tabbar_share_h5.zd {
  background: #f22321;
  border-radius: 20px;
}
.tabbar_share {
  width: 37%;
  background: linear-gradient(
    -15deg,
    rgba(244, 65, 66, 1),
    rgba(254, 144, 123, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}
/* 关注公众号 */
.msg-box {
  position: absolute;
  top: 3rem;
  left: 1.05rem;
  width: 5rem;
  height: 5rem;
  border-radius: 8px;
  padding: 0.5rem 0.2rem;
  background: #fff;
}
.qr-code {
  width: 4rem;
  height: 4rem;
  margin: 0 auto;
}
.qr-code > img {
  width: 100%;
  height: 100%;
}
.qr-text{
  width: 100%;
  padding: .2rem 0;
  text-align: center;
  font-size: .3rem;
  font-weight: 500;
  height: .5rem;
  line-height: .5rem;
}
.close {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
  top: 6.2rem;
  left: 50%;
  margin-left: -0.4rem;
}
.close > img {
  width: 100%;
  height: 100%;
}
/* 保存海报 */
.p2 {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #565656;
}

.poster {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
}

.poster img {
  width: 100%;
}

.note-layer2 {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1.4rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.note-layer2 div {
  font-size: 0.32rem;
  line-height: 0.4rem;
  text-align: center;
  color: #c9000f;
  font-weight: 500;
}

.note-layer2 div:last-child {
  color: #c9000f;
}

.common-btn {
  position: fixed;
  top: 2.5rem;
  right: 0;
  width: 0.8rem;
  height: 0.8rem;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: rgba(116, 165, 242, 1);
}

.common-btn.c1 {
  background-image: url("http://assets.rurushishi.com/activies/car-default/dianhua.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 0.5rem 0.5rem;
}

.common-btn.c2 {
  background-image: url("http://assets.rurushishi.com/activies/car-default/fanhui.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 0.5rem 0.5rem;
}

.live_share_guide_btn {
  position: absolute;
  bottom: 1rem;
  left: 0.65rem;
  right: .65rem;
  background: #E9D29D;
  color: #8B663A;
  border-radius: 5px;
  font-size: 18px;
  text-align: center;
  padding: 16px 0;
}

.share-top {
  position: absolute;
  top: .96rem;
  left: 50%;
  right: 1.5rem;
  width: 4.92rem;
  background: url(http://assets.rurushishi.com/live_room/sharetop.png)no-repeat;
  background-size: 4.92rem .86rem;
  height: .86rem;
  text-align: center;
  font-size: 18px;
  z-index: 2;
  /* padding: 12px 0; */
  color: #DBB282;
  line-height: .86rem;
  margin-left: -2.46rem;
}
</style>